import { trustSignals, platformSignals } from '@/mocks/trustSignals';

export default function TrustSignalsSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold uppercase tracking-wide mb-4">
            Trust &amp; Reliability
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 tracking-tight">
            Trusted Mulebuy Spreadsheet Resource
          </h2>
          <p className="text-foreground-500 text-base md:text-lg mt-4 max-w-2xl mx-auto">
            This website is built with structured informational standards to provide reliable Mulebuy spreadsheet knowledge.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-14">
          {trustSignals.map((signal) => (
            <div
              key={signal.title}
              className="bg-secondary-50 rounded-xl p-5 border border-secondary-200 flex flex-col items-center text-center gap-3"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100">
                <i className={`${signal.icon} text-xl text-secondary-700`}></i>
              </div>
              <p className="text-sm font-medium text-foreground-800">{signal.title}</p>
            </div>
          ))}
        </div>

        <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
          <h3 className="font-heading text-xl font-bold text-foreground-950 mb-6">Platform Reliability Signals</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {platformSignals.map((signal) => (
              <div key={signal.title} className="flex items-start gap-3">
                <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100">
                  <i className={`${signal.icon} text-primary-600`}></i>
                </div>
                <p className="text-sm text-foreground-600">{signal.title}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 p-6 md:p-8 bg-accent-50 rounded-2xl border border-accent-100">
          <h3 className="font-heading text-lg font-bold text-foreground-950 mb-4 flex items-center gap-2">
            <i className="ri-shield-check-line text-accent-600"></i>
            Content Integrity Statement
          </h3>
          <p className="text-foreground-600 leading-relaxed">
            This platform is designed as an <strong className="text-foreground-800">informational knowledge hub about Mulebuy spreadsheet systems</strong>, focusing on education, comparison analysis, workflow understanding, and structured data explanation. All case studies and reviews are for illustrative purposes to demonstrate typical user patterns with spreadsheet-based sourcing methods.
          </p>
        </div>
      </div>
    </section>
  );
}